const PolicyContent = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-lg p-12 border border-[#FFE5D4]">
          <div className="bg-[#FFF8F0] border-l-4 border-[#FF8C42] p-6 rounded-lg mb-12">
            <p className="text-[#2A2A2A] leading-relaxed">
              Sodrel Logistics LLC ("we," "our," or "us") is committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our services.
            </p>
          </div>

          <div className="space-y-12">
            <div className="relative">
              <span className="text-[80px] font-bold text-[#FF8C42]/10 absolute -top-4 -left-4">01</span>
              <div className="relative z-10">
                <h2 className="text-3xl font-bold text-[#2A2A2A] mb-6">
                  Information We Collect
                </h2>
                <p className="text-[#6B6B6B] text-lg leading-relaxed mb-6">
                  We collect information that you provide directly to us, including:
                </p>
                
                <h3 className="text-xl font-semibold text-[#FF8C42] mb-3">
                  Personal Information
                </h3>
                <ul className="space-y-3 ml-6 mb-6">
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Name, email address, phone number, and mailing address</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Company name and business information</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Payment and billing information</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Account credentials and login information</span>
                  </li>
                </ul>

                <h3 className="text-xl font-semibold text-[#FF8C42] mb-3">
                  Shipment Information
                </h3>
                <ul className="space-y-3 ml-6 mb-6">
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Pickup and delivery addresses</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Freight details, weight, and dimensions</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Tracking and delivery information</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Special handling instructions</span>
                  </li>
                </ul>

                <h3 className="text-xl font-semibold text-[#FF8C42] mb-3">
                  Automatically Collected Information
                </h3>
                <ul className="space-y-3 ml-6">
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">IP address and device information</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Browser type and operating system</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Website usage data and analytics</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Cookies and similar tracking technologies</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="relative">
              <span className="text-[80px] font-bold text-[#FF8C42]/10 absolute -top-4 -left-4">02</span>
              <div className="relative z-10">
                <h2 className="text-3xl font-bold text-[#2A2A2A] mb-6">
                  How We Use Your Information
                </h2>
                <p className="text-[#6B6B6B] text-lg leading-relaxed mb-6">
                  We use the information we collect for the following purposes:
                </p>
                <ul className="space-y-3 ml-6">
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">To provide, maintain, and improve our logistics services</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">To process and fulfill shipment requests</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">To communicate with you about your shipments and account</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">To process payments and prevent fraudulent transactions</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">To send marketing communications (with your consent)</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">To comply with legal obligations and resolve disputes</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">To analyze usage patterns and improve our website</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="relative">
              <span className="text-[80px] font-bold text-[#FF8C42]/10 absolute -top-4 -left-4">03</span>
              <div className="relative z-10">
                <h2 className="text-3xl font-bold text-[#2A2A2A] mb-6">
                  Information Sharing and Disclosure
                </h2>
                <p className="text-[#6B6B6B] text-lg leading-relaxed mb-6">
                  We may share your information in the following circumstances:
                </p>
                
                <h3 className="text-xl font-semibold text-[#FF8C42] mb-3">
                  Service Providers
                </h3>
                <p className="text-[#6B6B6B] leading-relaxed mb-6">
                  We may share information with third-party service providers who perform services on our behalf, including payment processing, data analysis, email delivery, and customer service.
                </p>

                <h3 className="text-xl font-semibold text-[#FF8C42] mb-3">
                  Business Partners
                </h3>
                <p className="text-[#6B6B6B] leading-relaxed mb-6">
                  We may share information with partner carriers and logistics providers to facilitate shipment delivery and tracking.
                </p>

                <h3 className="text-xl font-semibold text-[#FF8C42] mb-3">
                  Legal Requirements
                </h3>
                <p className="text-[#6B6B6B] leading-relaxed mb-6">
                  We may disclose information if required by law, court order, or governmental regulation, or to protect our rights, property, or safety.
                </p>

                <div className="bg-[#FFF8F0] border-l-4 border-[#FF8C42] p-6 rounded-lg">
                  <p className="text-[#2A2A2A] font-semibold mb-2">
                    <i className="ri-shield-check-line text-[#FF8C42] mr-2"></i>
                    Your Privacy Matters
                  </p>
                  <p className="text-[#6B6B6B]">
                    We do not sell, rent, or trade your personal information to third parties for their marketing purposes without your explicit consent.
                  </p>
                </div>
              </div>
            </div>

            <div className="relative">
              <span className="text-[80px] font-bold text-[#FF8C42]/10 absolute -top-4 -left-4">04</span>
              <div className="relative z-10">
                <h2 className="text-3xl font-bold text-[#2A2A2A] mb-6">
                  Data Security
                </h2>
                <p className="text-[#6B6B6B] text-lg leading-relaxed mb-6">
                  We implement appropriate technical and organizational measures to protect your personal information:
                </p>
                <ul className="space-y-3 ml-6">
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Encryption of sensitive data during transmission and storage</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Regular security assessments and updates</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Access controls and authentication procedures</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Employee training on data protection practices</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]">Secure data backup and disaster recovery procedures</span>
                  </li>
                </ul>
                <p className="text-[#6B6B6B] leading-relaxed mt-6">
                  While we strive to protect your information, no method of transmission over the internet or electronic storage is 100% secure. We cannot guarantee absolute security.
                </p>
              </div>
            </div>

            <div className="relative">
              <span className="text-[80px] font-bold text-[#FF8C42]/10 absolute -top-4 -left-4">05</span>
              <div className="relative z-10">
                <h2 className="text-3xl font-bold text-[#2A2A2A] mb-6">
                  Your Privacy Rights
                </h2>
                <p className="text-[#6B6B6B] text-lg leading-relaxed mb-6">
                  You have the following rights regarding your personal information:
                </p>
                <ul className="space-y-3 ml-6">
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]"><strong className="text-[#FF8C42]">Access:</strong> Request access to your personal information</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]"><strong className="text-[#FF8C42]">Correction:</strong> Request correction of inaccurate information</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]"><strong className="text-[#FF8C42]">Deletion:</strong> Request deletion of your personal information</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]"><strong className="text-[#FF8C42]">Opt-Out:</strong> Unsubscribe from marketing communications</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]"><strong className="text-[#FF8C42]">Portability:</strong> Request a copy of your data in a portable format</span>
                  </li>
                </ul>
                <p className="text-[#6B6B6B] leading-relaxed mt-6">
                  To exercise these rights, please contact us using the information provided below.
                </p>
              </div>
            </div>

            <div className="relative">
              <span className="text-[80px] font-bold text-[#FF8C42]/10 absolute -top-4 -left-4">06</span>
              <div className="relative z-10">
                <h2 className="text-3xl font-bold text-[#2A2A2A] mb-6">
                  Cookies and Tracking Technologies
                </h2>
                <p className="text-[#6B6B6B] text-lg leading-relaxed mb-6">
                  We use cookies and similar tracking technologies to enhance your experience:
                </p>
                <ul className="space-y-3 ml-6">
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]"><strong>Essential Cookies:</strong> Required for website functionality</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]"><strong>Analytics Cookies:</strong> Help us understand website usage</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]"><strong>Preference Cookies:</strong> Remember your settings and preferences</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3 mt-2"></span>
                    <span className="text-[#6B6B6B]"><strong>Marketing Cookies:</strong> Deliver relevant advertisements</span>
                  </li>
                </ul>
                <p className="text-[#6B6B6B] leading-relaxed mt-6">
                  You can control cookies through your browser settings. However, disabling cookies may affect website functionality.
                </p>
              </div>
            </div>

            <div className="relative">
              <span className="text-[80px] font-bold text-[#FF8C42]/10 absolute -top-4 -left-4">07</span>
              <div className="relative z-10">
                <h2 className="text-3xl font-bold text-[#2A2A2A] mb-6">
                  Data Retention
                </h2>
                <p className="text-[#6B6B6B] text-lg leading-relaxed">
                  We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required by law. Shipment records are typically retained for 7 years in accordance with transportation regulations.
                </p>
              </div>
            </div>

            <div className="relative">
              <span className="text-[80px] font-bold text-[#FF8C42]/10 absolute -top-4 -left-4">08</span>
              <div className="relative z-10">
                <h2 className="text-3xl font-bold text-[#2A2A2A] mb-6">
                  Children's Privacy
                </h2>
                <p className="text-[#6B6B6B] text-lg leading-relaxed">
                  Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children. If you believe we have collected information from a child, please contact us immediately.
                </p>
              </div>
            </div>

            <div className="relative">
              <span className="text-[80px] font-bold text-[#FF8C42]/10 absolute -top-4 -left-4">09</span>
              <div className="relative z-10">
                <h2 className="text-3xl font-bold text-[#2A2A2A] mb-6">
                  Changes to This Privacy Policy
                </h2>
                <p className="text-[#6B6B6B] text-lg leading-relaxed">
                  We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. We encourage you to review this Privacy Policy periodically.
                </p>
              </div>
            </div>

            <div className="relative">
              <span className="text-[80px] font-bold text-[#FF8C42]/10 absolute -top-4 -left-4">10</span>
              <div className="relative z-10">
                <h2 className="text-3xl font-bold text-[#2A2A2A] mb-6">
                  Contact Us
                </h2>
                <p className="text-[#6B6B6B] text-lg leading-relaxed mb-6">
                  If you have questions or concerns about this Privacy Policy or our data practices, please contact us:
                </p>
                <div className="bg-gradient-to-r from-[#FF8C42] to-[#D4693A] rounded-2xl p-8 text-white">
                  <h3 className="text-2xl font-bold mb-6">Get In Touch</h3>
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <i className="ri-building-line text-2xl mr-4"></i>
                      <div>
                        <p className="text-sm text-white/80">Company</p>
                        <p className="text-lg font-semibold">Sodrel Logistics LLC</p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <i className="ri-map-pin-fill text-2xl mr-4 mt-1"></i>
                      <div>
                        <p className="text-sm text-white/80">Address</p>
                        <p className="text-lg font-semibold">
                          1 Sodrel Dr, Jeffersonville, IN 47129-2826
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-phone-fill text-2xl mr-4"></i>
                      <div>
                        <p className="text-sm text-white/80">Phone</p>
                        <a href="tel:+13172460584" className="text-lg font-semibold hover:text-white/90 cursor-pointer">
                          +1 (317) 246-0584
                        </a>
                      </div>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-mail-fill text-2xl mr-4"></i>
                      <div>
                        <p className="text-sm text-white/80">Email</p>
                        <a href="mailto:sodrel@michaellogistics.com" className="text-lg font-semibold hover:text-white/90 cursor-pointer break-all">
                          sodrel@michaellogistics.com
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PolicyContent;